import { Injectable } from '@angular/core';

import { RestfulService } from '@app/service/restful.service';

@Injectable({
  providedIn: 'root'
})
export class MainService {

  constructor(
    private restful: RestfulService,
  ) { }

  private handleErrorPromise(error: Response | any) {
    console.log(error.message || error);
    return Promise.reject(error.message || error);
  }

  //  뉴스 가져오기
  getBoardNews( params ): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'main',
        version: '1.0',
        action: 'getBoardNews'
      }, params
    ).then( response => {
      return response || [];
    })
     .catch(this.handleErrorPromise);
  }

}
